import {ChartsModel} from "interfaces";

export const chartsInitialState: ChartsModel = {
  totalClientes: 0,
  montoFinanzas: "",
  totalProductos: 0,
  finanzasChart: [],
  montoCobranzas: "",
  totalFormularios: 0,
  formulariosChart: [],
  montoPaymentReports: 0,
};
